export default __webpack_public_path__ + "static/media/double-moon-1.0a7cfa1e.webp";